import { Directive } from '@angular/core';

import './VbBtn.Directive.less';

@Directive({
	selector: '[vbBtnWhite]',
	host: {
		'class': 'btn vbBtn btnWhite'
	}
})
export class VbBtnWhiteDirective {}
